export default {
  homepage: {
    title: 'Royalty Free Music for Your Videos | Loudly',
    description:
      'Download our royalty free music for your videos. Find the perfect background music for your blogs, YouTube channels, podcasts and more.',
  },
  selectedTags: {
    title: 'Royalty Free value Music | Loudly',
    description:
      'Discover royalty free songs from value key. Find the perfect royalty free track that fits your project and use it on YouTube.',
  },
  aiGenerator: {
    title: 'AI Music Generator | Loudly',
    description: `Explore Loudly's rapidly evolving AI Music Generator which makes it easier than ever to create and customize high-quality music. Get inspired, create your own tracks!`,
  },
  pricing: {
    title: 'Pricing for Royalty Free Music | Loudly',
    description:
      'Select the best plan that fits your business needs to download background music for your videos. Get full access to our royalty free songs',
  },
  library: {
    title: 'My Library | Loudly',
    description:
      'Listen, download or remove the songs you previously added to your library.',
  },
  subscription: {
    title: 'My Subscriptions | Loudly',
    description:
      'You can manage your active subscriptions. Make sure you select the best plan that fits your needs.',
  },
  account: {
    title: 'My Account | Loudly',
    description:
      'You can edit your account info. Please make sure you type in the correct info.',
  },
  login: {
    title: 'Login | Loudly',
    description:
      'Please login to access your account. Once you log in, you will be able to use our royalty free music solutions.',
  },
  register: {
    title: 'Create Account | Loudly',
    description:
      'Create an account and have access to the Loudly experience. Create, discover and download royalty-free music. Sign up now for free.',
  },
};
